import React from "react";
import styled from "styled-components";
import { withTheme } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Root = styled.div`
  width: 100%;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  padding: 10px;
  border-radius: 8px;
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1) 0s;
  background: white;
  margin-top: 10px;
`;

export default withTheme(({ children }) => {
  return <Root>{children}</Root>;
});
